import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import {
    fetchProductInfo,
    fetchVehicleInfo,
    formCalculatorLoanInfo,
    FormTypeCalculatorLoanInfo,
    FormTypeCalculatorVehicleInfo,
    updateLoanType,
} from '../../actions';
import { loanCalculatorNextEvent } from '../../actions/steps/calculator';
import { DispatchWithState, StringKeyAnyValue, StringKeyValue } from '../../actions/types';
import { AppState } from '../../reducers';
import { CalculatorReducer } from '../../reducers/calculator';
import { ContextReducer } from '../../reducers/context';
import { LoaderReducer } from '../../reducers/loader';
import { VehicleReducer } from '../../reducers/vehicle';
import LoanCalculator from './LoanCalculator';

interface Props {
    action: {
        fetchProductInfo: (vehicleURL: string) => DispatchWithState;
        fetchVehicleInfo: (form: FormTypeCalculatorVehicleInfo) => DispatchWithState;
        loanCalculatorNextEvent: (form: FormTypeCalculatorLoanInfo) => DispatchWithState;
        updateLoanType: (loanType: string) => void;
    };
    calculator: CalculatorReducer;
    context: ContextReducer;
    form: StringKeyAnyValue;
    vehicle: VehicleReducer;
    loader: LoaderReducer;
    text: StringKeyValue;
}

const LoanCalculatorContainer = (props: Props): JSX.Element => {
    const { action, calculator, vehicle, context, loader, text, form } = props;
    return (
        <LoanCalculator
            action={action}
            calculator={calculator}
            vehicle={vehicle}
            context={context}
            loader={loader}
            text={text}
            form={form}
        />
    );
};

const mapStateToProps = (state: AppState) => ({
    form: state.context.config.data.form,
    text: state.context.config.data.text,
    calculator: state.calculator,
    vehicle: state.vehicle,
    context: state.context,
    loader: state.loader,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    action: bindActionCreators(
        {
            loanCalculatorNextEvent,
            formCalculatorLoanInfo,
            fetchVehicleInfo,
            fetchProductInfo,
            updateLoanType,
        },
        dispatch,
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoanCalculatorContainer);
